import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=430ecb30&scoped=true&"
import script from "./ButtonDefault.vue?vue&type=script&lang=ts&"
export * from "./ButtonDefault.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=430ecb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ecb30",
  null
  
)

export default component.exports